// Messages (de)

const config = {
  code: 'de',
  label: 'Deutsch',
  label_en: 'German',
  rtl: false,
};

const messages = {
  // Navbar
  navbar_title: 'Abmelden',

  // Unsubscribe page
  unsubpage_title: 'Bist du sicher, dass du dich abmelden möchtest?',
  unsubpage_msg1:
    'Falls du keine Marketing Kommunikationen mehr von uns erhalten möchtest, klicke bitte auf den folgenden Link.',
  unsubpage_unsubscribe: 'Abmelden',
  unsubpage_unsubscribing: 'Abmelden...',
  unsubpage_result_success: 'Du hast dich erfolgreich abgemeldet.',
  unsubpage_result_error: 'Abmeldung fehlgeschlagen.',

  // Error page
  errorpage_title: 'Oops!',
  errorpage_msg1: 'Dieser Link ist abgelaufen.',
  errorpage_msg2: 'Wir konnten die Anfrage nicht bearbeiten.',
};

const lang = { config, messages };

export default lang;
